import React from "react";
import styles from "./SectionOffer.module.scss";
import Button from "../Button/Button";
import LazyImage from "../LazyImage/LazyImage";
import {useModal} from "../../context/ModalContext";

const SectionOffer: React.FC = () => {
    const {openModalA} = useModal();

    return (
        <div className={styles.sectionOffer}>
            <LazyImage className={styles.sectionOfferImage}
                       src="./assets/images/general/sectionOffer.png"
                       alt=" Оформите «Life Care» и получите незаменимые сервисы от «ELS GROUP»"
            />
            <div className={styles.sectionOfferRow}>
                <p className={styles.sectionOfferTitle}>
                    Оформите «Life Care» и получите незаменимые сервисы от «ELS GROUP»
                </p>
                <p className={styles.sectionOfferText}>
                    Откройте для себя «Life Care» — уникальную программу, которая предлагает незаменимые сервисы для
                    заботы
                    о вашем здоровье и благополучии. С нашим комплексным подходом вы получите доступ к
                    высококачественным
                    медицинским услугам и профессиональной поддержке от «ELS GROUP».
                </p>
                <Button className={styles.sectionOfferButton}
                        classButton="redButton"
                        onClick={openModalA}
                >
                    Подключить
                </Button>
            </div>
        </div>
    )
}

export default SectionOffer;